import {ChangeDetectionStrategy, Component} from '@angular/core';
import {PermissionService} from '../../../services';
import {CommonModule} from "@angular/common";

@Component({
    selector: 'app-base',
    imports: [CommonModule],
    templateUrl: './base.component.html',
    styleUrls: ['./base.component.css'],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class BaseComponent {
    constructor(public permissionService: PermissionService) {}
}
